<!--
<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mb-0">
            ÁLBUMES DE AUTÓGRAFOS <br>
           <br>           
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio26/maria-alvarado">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio26/maria-alvarado">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio26/maria-alvarado">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio27/ALBUMES-000.jpg">
</section>
-->
<div class="fondoBlanco_IMG1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col bott p-0">
                        <img class="LineSubsec_Izq bottom_cel mt-3" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-014.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-014.png">
                    </div>
                    <div class="col-sm-7">
                        <p style="line-height: 100%;margin-bottom: 5%;"
                            class="fontMS700 text-center colorPrincipal  font-38">
                            DETRÁS DE LOS EXLIBRIS EN EL PERÚ
                        </p>
                    </div>
                    <div class="col">
                        <img class="LineSubsec_Izq bottom_cel mt-3" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-014.png">
                            <br>
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: -8%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-014.png">
                            <br>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p style="line-height: 100%;margin-bottom: 5%;"
                        class="fontMS100 text-right colorPrincipal  font-35 pi-5" >
                        IDENTIDAD, ESTÉTICA Y TIPOLOGÍAS EN LAS MARCAS 
                        DE POSESIÓN DE LOS LIBROS DE LA BNP ENTRE LOS 
                        SIGLOS XVII-XVIII
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                
                <a href="http://hdl.handle.net/20.500.14428/79217" 
                target="_blank" style="color: black;">
                    <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-000.gif">
                </a>
               
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="fontMS100 text-justify font-24 mt-5 pi-5 pd-5">
                            <br>
                            <span class="fontMS500 font-26">D</span>ENOMINAMOS EXLIBRIS A LAS MARCAS, 
                            ETIQUETAS O SELLOS, YA SEAN MANUSCRITOS O IMPRESOS QUE SE COLOCAN EN LOS 
                            LIBROS PARA INDICAR A QUIÉN LE PERTENECEN. <br><br>
                            ESTA PALABRA SIGNIFICA “DE ENTRE LOS LIBROS”. 
                            LOS EXLIBRIS SUELEN LLEVAR EL NOMBRE DEL PROPIETARIO Y ALGUNA IMAGEN, 
                            SIENDO COMUNES LOS ESCUDOS FAMILIARES O FIGURAS ALEGÓRICAS VINCULADAS 
                            A LA PROFESIÓN O ACTIVIDAD DEL DUEÑO.

                            <br>
                        </p>
                    </div>
                        <div class="col-sm-1"></div>
                    
                </div>
                <div class="row">
                        <div class="col-sm-1"></div>
                        <div class="col-sm-5">
                        <p class="text-justify font-20 mt-5 pi-8" >
                            <br><br>
                            <span class="fontMS500 font-24">E</span>stas marcas no solo indican 
                            propiedad, sino que tienen un valor estético e íntimo: brindando información 
                            sobre el propietario, su trayectoria, personalidad y gustos, así como 
                            sobre las ideas de su época, entre otra información valiosa. 
                        </p>
                        </div>
                        <div class="col-sm-6">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-exlibris-1/22/" 
                            target="_blank" style="color: black;">
                                <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-001.png">
                            </a>                        
                        </div>
                </div>
                    
                
            </div>
        </div>
    </div>
</div>


<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5 ">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-016.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-016.png">
                    </div>
                    <div class="col-sm-5">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-derecha font-38 ">
                            ¿CÓMO LLEGARON<br>
                            LOS EXLIBRIS AL PERÚ?
                        </p>

                        <div class="col-sm-1"></div>
                        
                    </div>
                        
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-016.png">
                    </div>
                    
                        
                    <div class="col-sm-2"></div>
                        <div class="col-sm-9">
                            <p class="fontMS100 font-24 ">
                                <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-exlibris-1/42/" 
                            target="_blank" style="color: black;">
                                <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-002.png">
                            </a>  
                                <br>
                            </p>
                        </div>
                    <div class="col-sm-1"></div>

                    <div class="col-sm-1"></div>
                        <div class="col-sm-10">
                            <p class="fontMS500 text-justify font-20 mt-2">
                                <br>
                                <span class="fontMS500 font-26">S</span>abemos que el primer exlibris de la historia proviene de Egipto. 
                                Estos llegaron a América en el siglo XVII y al virreinato peruano en el siglo XVIII.
                                <br><br>
                                La Biblioteca Nacional del Perú cuenta con dos álbumes de etiquetas o exlibris. 
                                Gracias a estos se ha podido conocer o confirmar -según sea el caso- la procedencia 
                                de algunos libros que la biblioteca ha ido adquiriendo en diferentes momentos de su historia.
                            </p>
                        </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-017.gif">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 colorPrincipal text-center font-40">
                            CLASIFICANDO LAS MARCAS
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-017.gif">
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-017.gif">
                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="text-justify text-white fontMS100 font-24">
                            <br>
                            EN NUESTRO TERRITORIO, A LO LARGO DEL TIEMPO, LOS EXLIBRIS SE 
                            HAN PRESENTADO DENTRO DE DISTINTAS TIPOLOGÍAS: HERÁLDICA, 
                            TIPOGRÁFICA Y ALEGÓRICA.
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>

                    <div class="col-sm-1"></div>
                    <div class="col-sm-5 mt-2">
                        <p class=" colorPrincipal fontMS700 font-40">
                            <br>
                            DE ESCUDOS Y LIBROS: 
                            LA MARCA FAMILIAR
                            <br>
                        </p>
                        <p class="text-justify text-white fontMS100 font-24">
                            
                            <span class="fontMS500 font-26">L</span>os primeros exlibris del virreinato 
                            peruano son del tipo “heráldico”, es decir, plasman en esta marca de propiedad 
                            la imagen de los escudos familiares.  <br><br>
                            Estas marcas fueron utilizadas por los miembros de las élites y la nobleza 
                            colonial para mostrar su linaje y estatus social.
                            <br>
                        </p>

                    </div>
                    <div class="col-sm-5 mt-2">
                        <p class="fontMS100 font-24 mt-5">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-exlibris-1/14/" 
                        target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-003.png"
                            style="border: 8px solid #ffffff;">
                        </a>  

                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco_IMG2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700  text-center font-40 mt-8" style="color:#465a65">
                            NUESTRO PRIMER EXLIBRIS
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-001.png">
                    </div>
                    
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-001.png">
                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="fontMS100 font-24 mt-3">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-exlibris-1/8/" 
                        target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-004.jpg"
                            style="border: 8px solid #465861;">
                        </a>  
                        </p>
                        <p class="fontMS500 font-24 mt-5 text-justify text-gris">
                            <span class="fontMS700 font-26">E</span>l primer exlibris que se conoce impreso en el Perú 
                            data de 1733, es heráldico y perteneció a José Agustín Pardo de Figueroa, que fue un 
                            funcionario colonial, corregidor del Cusco entre los años de 1742-1744.<br><br>
                            Pardo, considerado una persona ilustre en Cusco, era un erudito en literatura y derecho, 
                            además de conocedor de diversos idiomas. Según Tauro del Pino (2001), su biblioteca contaba 
                            con 10 000 volúmenes que, además, tenían notas en los márgenes que expresaban su amplio y 
                            profundo conocimiento. Formó su biblioteca en Europa y América, y quiso hacerla de libre 
                            acceso, pero murió antes de lograrlo.
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <div class="row">
                            <div class="col-sm-6">
                                <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-005.jpg"
                                    style="border: 8px solid #465861;">
                            </div>
                            <div class="col-sm-6">
                                <p class="fontMS500 font-24 mt5 text-justify">
                                    En este escudo vemos a las águilas que representan a la familia Pardo 
                                    y a las cinco hojas de higuera o figuera que tomó por armas la familia Figueroa. 
                                
                                </p>

                            </div>

                        </div>
                        <br><br>
                        <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-006.jpg"
                        style="border: 8px solid #465861;">
                                <p class="fontMS100 font-24 text-justify">
                                    <br>
                                    También, vemos la firma de quien realizó este ex libris, Paulus Minguet 
                                    (1715(?)-1778). Este último, fue un famoso grabador de sellos, láminas 
                                    y firmas, así como un reconocido editor en España.
                                </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoVerdeO3">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-004.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700  text-center font-40 text-white" >
                            NUEVAS IDEAS E IDEALES:
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-004.png">
                    </div>
                    <div class="col-sm-1"></div>
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700  text-center font-40 text-white" >
                            LOS EXLIBRIS DE LA NUEVA REPÚBLICA
                        </p>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-004.png">
                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="fontMS500 font-24 mt-5 text-justify text-white">
                            <span class="fontMS500 font-26">H</span>acia fines del siglo XVIII 
                            e inicios del XIX, eran comunes los ex libris “tipográficos” que se 
                            caracterizaban por llevar el nombre del propietario y una ornamentación 
                            sencilla en los bordes, dejando atrás el estilo barroco o recargado.
                        </p>
                    </div>
                    <div class="col-sm-1"></div>

                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">

                        <p class="fontMS100 font-24 mt-5">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-exlibris-2/8/" 
                        target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-007.jpg">
                        </a>  
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                </div>



                <div class="row " style="background: #ffffff;">
                    <div class="col-sm-12">
                        
                            <div class="container">
                                <p class="fontMS500 font-24 text-justify">
                                    <br>
                                    Pero un estilo no anula al otro. Podemos encontrar ejemplos de la convivencia 
                                    de exlibris heráldicos y tipográficos en estos dos sellos de pertenencia a la 
                                    Compañía de Jesús: el primero del Coleegii Salvatoris que funcionó desde 1868, 
                                    colocado dentro de un escudo; y el segundo de la biblioteca de los padres de la 
                                    Compañía.  
                                
                                </p>

                            </div>

                        </div>
                        <br><br>
                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="fontMS100 font-24 mt-5 pi-5 pd-5">
                            <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-008.jpg">
                        </p>
                        <p class="fontMS500 font-24 mt-5 text-justify text-white">
                            La tendencia tras la Independencia para las marcas ostentosas de las familias 
                            virreinales será dar paso a una simplificación del diseño. Este estilo se puede 
                            encontrar en los exlibris de personajes independistas, intelectuales y clérigos, 
                            entre otros.
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoGris_Img3">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    
                    <div class="col-sm-6 ">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-001.png">
                    </div>
                    <div class="col-sm-5">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-derecha font-35 mt-10 colorPrincipal3">
                            EL SELLO DEL LIBERTADOR
                        </p>
                    </div>
                    <div class="col-sm-1"></div>   
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-001.png">
                    </div>

                    <div class="col-sm-1"></div>
                        <div class="col-sm-10">
                            <p class="fontMS500 text-justify font-20 mt-2">
                                <br>
                                <span class="font-24 " >D</span>on José de San Martín fue un 
                                gran lector y reafirmó sus ideales ilustrados cuando fundó la 
                                Biblioteca Nacional del Perú en 1821. Para contribuir con su acervo, 
                                donó alrededor de 700 libros de su propia colección, los que se 
                                reconocen por un exlibris sencillo, con orla en el borde, típico de su época.
                            </p>
                        </div>
                    <div class="col-sm-1"></div>
                        
                    <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <p class="fontMS100 font-24 ">
                                <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/theatre-de-voltaire-tome-quatrieme/2/" 
                            target="_blank" style="color: black;">
                                <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-009.gif"
                                style="border: 8px solid #465861;">
                            </a>  
                                <br>
                            </p>
                        </div>
                    <div class="col-sm-2"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700  text-center font-40 text-white" >
                            LAS MARCAS DE LOS LIBERTADORES
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="fontMS100 font-24 mt-5 text-justify text-white">
                            <span class="fontMS100 font-26">O</span>tros líderes y precursores de la 
                            Independencia siguieron el ejemplo de San Martín y donaron libros de 
                            sus propias colecciones a la naciente biblioteca. En los repositorios 
                            de la institución, se han encontrado exlibris de personajes como Hipólito Unanue 
                            y José Pezet y Monel, ejemplares que contienen marcas de pertenencias sencillas, 
                            con sus nombres y orlas. 
                        </p>
                    </div>
                    <div class="col-sm-1"></div>

                    <div class="col-sm-1"></div>
                    <div class="col-sm-10 " style="background: #ffffff;">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-6">
                                    <p class="fontMS100 font-24 ">
                                        <a href="http://hdl.handle.net/20.500.14428/79217" 
                                    target="_blank" style="color: black;">
                                        <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-010.png">
                                    </a>  
                                    </p>
                                </div>
                                <div class="col-sm-6">
                                    <p class="fontMS100 font-24 ">
                                        <a href="http://hdl.handle.net/20.500.14428/79217" 
                                    target="_blank" style="color: black;">
                                        <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-011.png">
                                    </a>  
                                    </p>
                                </div>
                            </div>
                            <p class="fontMS100Italic font-15 ">
                                Hipólito Unanue (1755-1833) fue un médico, intelectual y político peruano, quien firmó el Acta de Independencia del Perú en 1821. 
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-1"></div>

                    <div class="col-sm-3 mt-5"></div>
                    <div class="col-sm-6 mt-5" style="background: #ffffff;">
                        <div class="container">
                            <div class="row">
                                
                                <div class="col-sm-12">
                                    <p class="fontMS100 font-24 ">
                                        <a href="http://hdl.handle.net/20.500.14428/79217" 
                                    target="_blank" style="color: black;">
                                        <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-012.png">
                                    </a>  
                                    </p>
                                </div>
                                
                            </div>
                            <p class="fontMS100Italic font-18 text-right ">
                                José Pezet y Monel (1774-1825) fue un médico y político 
                                peruano, quien también firmó el Acta de Independencia 
                                y fue parte del Congreso Constituyente de 1822.                            </p>
                        </div>
                    </div>
                    <div class="col-sm-3 mt-5"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondogris_IMG3">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2"></div> 
                    <div class="col-sm-4 ">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-005.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-005.png">
                    </div>
                    <div class="col-sm-5">
                        <p style="line-height: 100%;margin-bottom: 0%; "
                            class="fontMS700 text-derecha font-40 colorPrincipal mt-1" >
                            DESDE LOS CLAUSTROS:
                        </p>
                    </div>
                        
                    <div class="col-sm-1"></div>   
                    
                    <div class="col-sm-11">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                        class="fontMS700 text-derecha font-40 colorPrincipal ">
                        LOS EXLIBRIS DE LOS MIEMBROS DE LA IGLESIA
                    </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-005.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2"></div>
                        <div class="col-sm-9">
                            <p class="fontMS500 text-justify font-20 mt-2">
                                <br>
                                <span class="font-24 ">L</span>a Biblioteca Nacional fue fundada 
                                en el local del antiguo colegio de la Compañía de Jesús -expulsada 
                                del Perú en 1767. Asimismo, se ordenó el traslado de la antigua 
                                colección de la orden que había quedado en manos de la Universidad 
                                de San Marcos. 
                            </p>
                        </div>
                    <div class="col-sm-1"></div>
                        
                    <div class="col-sm-3"></div>
                        <div class="col-sm-6">
                            <p class="fontMS100 font-24 ">
                                <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-013.jpg"
                                style="border: 8px solid #06b799;">
                            
                                <br>
                            </p>
                        </div>
                    <div class="col-sm-3"></div>

                    <div class="col-sm-2"></div>
                        <div class="col-sm-9">
                            <p class="fontMS500 text-justify font-20 mt-2">
                                <br>
                                <span class="font-24 ">S</span>iguiendo un estilo “tipográfico”, es decir, 
                                de ornamentación sencilla en los bordes y con el nombre del propietario,
                                tenemos los exlibris que proceden de la colección de la Compañía de Jesús 
                                y los que provienen de otros miembros eruditos de la Iglesia. 
                            </p>
                        </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <div class="row">
                            <div class="col-sm-6">
                                <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-014.png">
                            </div>
                            <div class="col-sm-6">
                                <p class="fontMS100Italic font-15 mt-10 text-left">
                                    <br><br>
                                    A la izquierda, exlibris de Juan Antonio Montenegro y Ubaldi (1782-1854), 
                                    cura y vicario de Moquegua, a quien se le considera el primer historiador 
                                    de dicha ciudad. Según su testamento, su colección de libros constaba de 
                                    1321 ejemplares. 
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <p class="fontMS100 font-15 mt-10 text-right">
                                    <br><br>
                                    A la derecha, exlibris de Agustín Guillermo Charún, clérigo y político que 
                                    llegó a ser obispo de Trujillo. Fue alumno de José Faustino Sánchez Carrión 
                                    y suscribió también el Acta de Independencia.
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-015.png">
                            </div>
                        </div>
                        <br><br>       
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div> 
                    <div class="col-sm-3 ">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-004.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-004.png">
                    </div>
                    <div class="col-sm-7">
                        <p style="line-height: 100%;margin-bottom: 0%; "
                            class="fontMS700 text-derecha font-40 text-white mt-1" >
                            UN SELLO PERSONAL: LOS EXLIBRIS
                        </p>
                    </div>
                        
                    <div class="col-sm-1"></div>   
                    
                    <div class="col-sm-11">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                        class="fontMS700 text-derecha font-40 text-white">
                        ALEGÓRICOS
                    </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-004.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3"></div>
                        <div class="col-sm-6">
                            <p class="fontMS100 font-24 mt-5">
                                <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-016.jpg"
                                style="border: 8px solid #000000;">
                            
                                <br>
                            </p>
                        </div>
                    <div class="col-sm-3"></div>
                        
                    <div class="col-sm-1"></div>
                        <div class="col-sm-10">
                            <p class="fontMS300 text-justify font-20 mt-2 text-white">
                                <br>
                                <span class="font-24 ">L</span>os exlibris alegóricos presentan 
                                imágenes que simbolizan cualidades e intereses de los propietarios. 
                                Estos empiezan a predominar en el siglo XIX y se popularizan en el siglo 
                                XX donde se ven influenciados por la estética modernista. 
                            </p>
                        </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoVerdeO2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div> 
                    <div class="col-sm-3 ">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-004.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-004.png">
                    </div>
                    <div class="col-sm-7">
                        <p style="line-height: 100%;margin-bottom: 0%; "
                            class="fontMS700 text-derecha font-40 text-white mt-1" >
                            LA FAMILIA FUENTES Y LOS LIBROS
                        </p>
                    </div>
                        
                    <div class="col-sm-1"></div>   
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-004.png">
                    </div>
                </div>

                <div class="row">

                    <div class="col-sm-1"></div>
                        <div class="col-sm-10">
                            <p class="fontMS300 text-justify font-20 mt-2 text-white">
                                <br>
                                <span class="font-24 ">E</span>l exlibris de Francisco A. 
                                Fuentes mantuvo la alegoría de su padre, el escritor Manuel 
                                Atanasio Fuentes. En él observamos un estante con puertas de 
                                vidrio cerradas, pero a través de las que se dejan ver libros. 
                                La alegoría hace alusión a la lectura y la formación intelectual. 
                            </p>
                        </div>
                    <div class="col-sm-1"></div>

                    <div class="col-sm-3"></div>
                        <div class="col-sm-6">
                            <p class="fontMS100 font-24 mt-5">
                                <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-017.jpg"
                                style="border: 8px solid #000000; border-width: 3px 3px 3px 3px; outline: 8px solid #ffffff;">
                            
                                <br>
                            </p>
                        </div>
                    <div class="col-sm-3"></div>
                        
                    
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco_IMG4">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div> 
                    <div class="col-sm-2 ">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-011.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-011.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 100%;margin-bottom: 0%; "
                            class="fontMS700 text-derecha font-40  mt-1 colorPrincipal" >
                            EX LIBRIS DE UN PINTOR FLORENTINO
                        </p>
                    </div>
                        
                    <div class="col-sm-1"></div>   
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-011.png">
                    </div>
                </div>

                <div class="row">

                <div class="col-sm-3"></div>
                <div class="col-sm-6">
                        <p class="fontMS100 font-24 mt-5">
                            <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-018.jpg">
                            <br>
                        </p>
                </div>
                <div class="col-sm-3"></div>


                    <div class="col-sm-1"></div>
                        <div class="col-sm-10">
                            <p class="fontMS300 text-justify font-24 mt-3 colorPrincipal">
                                <br>
                                <span class="font-26 ">E</span>n el ex libris de Augusto Burchi (1853-1919) 
                                observamos a una figura trabajando, tras ella la cúpula del Duomo de Florencia. 
                                El pintor realizó restauraciones y decoraciones en dicha ciudad. Su biblioteca 
                                se vendió en 1908, algunos ejemplares fueron adquiridos por un peruano.
                            </p>
                        </div>
                    <div class="col-sm-1"></div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2"></div> 
                    <div class="col-sm-2">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-001.png">
                    </div>
                    <div class="col-sm-7">
                        <p style="line-height: 100%;margin-bottom: 0%; "
                            class="fontMS700 text-derecha font-40 text-gris mt-3" >
                            EL EX LIBRIS DEL EXPLORADOR
                        </p>
                    </div>
                        
                    <div class="col-sm-1"></div>   
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio29/EXLIBRIS-LINEA-001.png">
                    </div>
                </div>

                <div class="row">

                    <div class="col-sm-1"></div>
                        <div class="col-sm-10">
                            <p class="fontMS300 text-justify font-20 mt-3 text-gris">
                                <br>
                                <span class="font-24 ">E</span>l ex libris de Hiram Bingham explorador 
                                y político estadounidense, que hizo pública la existencia de Machu Picchu 
                                en 1911, presenta un mapa de Sudamérica, sin fronteras, con solo los ríos 
                                visibles, ríos importantes como guías para los exploradores.
                            </p>
                        </div>
                    <div class="col-sm-1"></div>

                    <div class="col-sm-3"></div>
                    <div class="col-sm-6">
                            <p class="fontMS100 font-24 mt-5">
                                <img width="100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-019.jpg">
                                <br>
                            </p>
                    </div>
                    <div class="col-sm-3"></div>


                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-1">
                        <img src="\assets\images\micrositio\micrositio27\ALBUMES-025.png" >
                    </div>
                    <div class="col-sm-2"></div>
                    <div class="col-sm-5">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS300Italic text-white font-26 text-right">
                            <br><br><br><br>
                            PREGUNTAS PARA REFLEXIONAR
                        </p>
                        <img width="100%" src="\assets\images\micrositio\micrositio29\EXLIBRIS-DIALOGO-000.png" >
                    </div>
                </div>
                <div class="row">
                    <div class="col-1 " style="width: 2%">
                        <p class="text-white text-justify font-24">
                        1. <br>
                    </p>
                    </div>
                    <div class="col-sm-11">
                        <p class="text-white text-justify font-24">
                            ¿Cómo sería tu exlibris?<br><br>

                            Diseña tu propio exlibris, piensa si colarías tu nombre, parte de este, un apodo o quizá tus 
                            siglas. ¿Colocarías imágenes? ¿Cuáles serían, qué significarían? Piensa en tus gustos y 
                            aquello que te identifica y ¡manos a la obra!
                            <br>
                        </p>
                        <img width="50%" src="\assets\images\micrositio\micrositio29\EXLIBRIS-DIALOGO-000.png" >

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <img width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-001.png">
                    <br><br>
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center font-40" style="color: #465a65">
                            PARA SABER MÁS
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="fontMS500 font-24" style="color: #465a65">
                            
                            BIBLIOGRAFÍA
                            <br><br>
                        </p>                        
                        <div class="row" style="color: #465a65">
                            <div class="col-sm-1" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                                <br>
                            </div>
                            <div class="col-sm-11">
                                <p class="fontMS500 font-24" style="word-wrap: break-word;">
                                    <a href="https://upload.wikimedia.org/wikipedia/commons/2/20/Nobiliario_de_los_reinos_y_se%C3%B1or%C3%ADos_de_Espa%C3%B1a_..._ilustrado_con_un_diccionario_de_her%C3%A1ldica%2C_adornado_con_m%C3%A1s_de_dos_mil_escudos_de_armas_..._%28IA_bub_gb_EzbwpCtgm0cC%29.pdf" 
                                    target="_blank"
                                    style="color: #465a65;">
                                    Piferrer, F. (1859). Nobiliario de los Reinos y Señoríos de España. Madrid. <br>
                                    </a> 
                            </p>
                            </div>
                            <div class="col-sm-1" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                                <br>
                            </div>
                            <div class="col-sm-11">
                                <p class="fontMS500 font-24 " style="word-wrap: break-word;">
                                    Tauro del Pino, A. (2001). Enciclopedia ilustrada del Perú, 
                                    Tomo 12. Lima: Peisa.<br>
                                </p>
                            </div>
                            <div class="col-sm-1 mt-1 text-center" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                            </div>
                            <div class="col-sm-11 mt-1">
                                <p class="fontMS500 font-24" style="word-wrap: break-word;">
                                    Trillo, G. (2022). Exlibris / estudio y selección de Gerardo Trillo. Lima: Biblioteca Nacional 
                                    del Perú. (está en la BPD)
                            </p>
                            </div>
                            <div class="col-sm-1 mt-1 text-center" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                            </div>
                            <div class="col-sm-11 mt-1">
                                <p class="fontMS500 font-24" style="word-wrap: break-word;">
                                    <a href="https://revistafenix.bnp.gob.pe/index.php/fenix/article/view/573/1035" 
                                    target="_blank"
                                    style="color: #465a65;">
                                    Trillo, G. (2020). La memoria impresa: la Biblioteca Nacional del Perú 
                                    a través del ex libris. Fénix. Revista de la Biblioteca Nacional del Perú,
                                    (48), pp. 47- 79.
                                    </a>
                            </p>
                            </div>
                            <div class="col-sm-1 w8" >
                                <img  style="width: 100%"src="/assets/images/micrositio/micrositio29/EXLIBRIS-ICONO-000.png">
                            </div>
                            <div class="col-sm-11 ">
                                <p class="fontMS500 font-24 mt-3" style="word-wrap: break-word;">
                                    <a href="https://www.youtube.com/watch?v=cAWizlmp5mU&t=13s" target="_blank"
                                style="color: #465a65;">
                                    https://www.youtube.com/watch?v=cAWizlmp5mU&t=13s
                                    </a>
                            </p>
                            </div>
                            <div class="col-sm-1 w8" >
                                <img style="width: 100%" src="/assets/images/micrositio/micrositio29/EXLIBRIS-ICONO-000.png">
                            </div>
                            <div class="col-sm-11">
                                <p class="fontMS500 font-24 mt-3" style="word-wrap: break-word;">
                                    <a href="https://open.spotify.com/episode/0tFXxW7Akm1moFXYXyGGD8?si=e4a3ba50a077420d" target="_blank"
                                style="color: #465a65;">
                                https://open.spotify.com/episode/0tFXxW7Akm1moFXYXyGGD8?si=e4a3ba50a077420d
                                    </a>
                                    
                                <br><br>
                            </p>
                            </div>
                        </div>    
                    </div>
                    <div class="col-sm-1"></div>
            
            <div class="row">
                <div class="col-sm-12">
                    <img  width="100%"
                        src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-001.png">
                </div>
            </div>
    </div>
</div>